import { defineMessages } from 'react-intl'

const PROFILE_GENDER = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3
}

const PROFILE_GENDERS = Object.values(PROFILE_GENDER)

const labels = defineMessages({
  male: {
    id: 'ProfileGender.male',
    defaultMessage: 'Male',
    description: 'The label used for the male gender.'
  },
  female: {
    id: 'ProfileGender.female',
    defaultMessage: 'Female',
    description: 'The label used for the female gender.'
  },
  other: {
    id: 'ProfileGender.other',
    defaultMessage: 'Other',
    description: 'The label used for the female gender.'
  }
})

const PROFILE_GENDER_MESSAGE = {
  [PROFILE_GENDER.MALE]: labels.male,
  [PROFILE_GENDER.FEMALE]: labels.female,
  [PROFILE_GENDER.OTHER]: labels.other
}

const PROFILE_GENDER_COMMON_PLURAL_MESSAGE = {
  [PROFILE_GENDER.MALE]: 'Men',
  [PROFILE_GENDER.FEMALE]: 'Women',
  [PROFILE_GENDER.OTHER]: ''
}

const PROFILE_GENDER_SEARCH_REGEXP = {
  [PROFILE_GENDER.MALE]: 'men’s|upper',
  [PROFILE_GENDER.FEMALE]: 'women’s|lower|glute',
  [PROFILE_GENDER.OTHER]: ''
}

const PROFILE_GENDER_COMMON_PLURAL_MESSAGES = Object.values(
  PROFILE_GENDER_COMMON_PLURAL_MESSAGE
)

export {
  PROFILE_GENDER,
  PROFILE_GENDERS,
  PROFILE_GENDER_MESSAGE,
  PROFILE_GENDER_COMMON_PLURAL_MESSAGE,
  PROFILE_GENDER_COMMON_PLURAL_MESSAGES,
  PROFILE_GENDER_SEARCH_REGEXP
}
